/**
 * Helper component to handle pagination UI on any lists
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';

// import third-party libraries
import classNames from 'classnames';

// import components
import Base from '../BaseComponent.js.jsx';

class Pagination extends Base {
  constructor(props) {
    super(props);
    this.state = {}
    this._bind(
      '_handleNext'
      , '_handlePrevious'
      , '_jumpToPage'
    )
  }

  _handlePrevious() {
    // Make a copy so we aren't accidentally mutating state in the reducer.
    let newPagination = _.cloneDeep(this.props.pagination);
    newPagination.page--;
    this.props.setPagination(newPagination);
  }

  _handleNext() {
    let newPagination = _.cloneDeep(this.props.pagination);
    newPagination.page++;
    this.props.setPagination(newPagination);
  }

  _jumpToPage(page) {
    let newPagination = _.cloneDeep(this.props.pagination);
    newPagination.page = parseInt(page);
    this.props.setPagination(newPagination);
  }

  render() {
    const { classes, pagination, totalPages } = this.props;
    let before;
    let after;
    let currentPage = pagination.page;

    /**
     * determine how many pages came before the current page and display (at most)
     * the three most recent
     */
    if(currentPage === 1) {
      before = [];
    } else if(currentPage === 2) {
      before = [ 1 ];
    } else if(currentPage === 3) {
      before = [1,2];
    } else {
      before = [ (currentPage - 3), (currentPage - 2), (currentPage - 1) ];
    }

    /**
     * determine how many pages come after the current page and display (at most)
     * the next three
     */
    if(currentPage === totalPages) {
      after = [];
    } else if(currentPage === totalPages - 1) {
      after = [currentPage + 1 ];
    } else if(currentPage === totalPages - 2) {
      after = [(currentPage + 1), (currentPage + 2) ]
    } else {
      after = [(currentPage + 1), (currentPage + 2), (currentPage + 3) ]
    }

    let prevClass = classNames(
      'prev-page'
      , {'disabled': currentPage === 1 }
    )

    let nextClass = classNames(
      'next-page'
      , {'disabled': currentPage === totalPages }
    )

    let ulClass = classNames(
      "pagination"
      , "u-centerText"
      , {
        [classes]: classes && classes.length > 0
      }
    )

    return (
      <ul className={ulClass}>
        <li >
          <a
            className={prevClass}
            onClick={currentPage > 1 ? this._handlePrevious : null }
          >
            <i className="fa fa-angle-double-left" /> Previous
          </a>
        </li>
        { currentPage > 4 ?
          <li>...</li>
          :
          null
        }
        { before.map((page, i) =>
          <li key={i} >
            <a className="page-num" onClick={()=> this._jumpToPage(page)}>{page}</a>
          </li>
        )}
        <li >
          <span className="current-page">{currentPage}</span>
        </li>
        { after.map((page, i) =>
          <li key={i} >
            <a className="page-num" onClick={()=> this._jumpToPage(page)}>{page}</a>
          </li>
        )}
        { currentPage < totalPages - 3 ?
          <li>...</li>
          :
          null
        }
        <li >
          <a
            className={nextClass}
            onClick={currentPage < totalPages ? this._handleNext : null }
          >
           Next <i className="fa fa-angle-double-right" />
          </a>
        </li>
      </ul>
    )
  }
}

Pagination.propTypes = {
  classes: PropTypes.string
  , pagination: PropTypes.shape({
    page: PropTypes.number.isRequired
    , per: PropTypes.number.isRequired
  }).isRequired
  , totalPages: PropTypes.number.isRequired
  , setPagination: PropTypes.func.isRequired
}

Pagination.defaultProps = {
  classes: ''
}

export default Pagination;



// WEBPACK FOOTER //
// global/components/helpers/Pagination.js.jsx